import { render, staticRenderFns } from "./wanjiaPriceMaintainImport.vue?vue&type=template&id=071fa11b&scoped=true&"
import script from "./wanjiaPriceMaintainImport.vue?vue&type=script&lang=js&"
export * from "./wanjiaPriceMaintainImport.vue?vue&type=script&lang=js&"
import style0 from "./wanjiaPriceMaintainImport.vue?vue&type=style&index=0&id=071fa11b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071fa11b",
  null
  
)

export default component.exports